import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Select } from 'antd'
import PropTypes from 'prop-types'

/**
 * Normaliza string removendo acentos e convertendo para minúsculas
 * para comparação que ignora acentuação
 */
const normalizarString = (str) => {
  if (!str) return ''
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

const flattenMenuItems = (items, parents = []) => {
  let flattened = []

  items.forEach((item) => {
    if (item.path) {
      const groupPath = parents.length > 0 ? `${parents.join(' > ')} > ` : ''
      flattened.push({
        key: item.path,
        value: item.path,
        label: item.label,
        fullLabel: `${groupPath}${item.label}`
      })
    }

    if (item.subitems) {
      const newParents = [...parents]
      if (!item.path) {
        newParents.push(item.label)
      }
      flattened = flattened.concat(flattenMenuItems(item.subitems, newParents))
    }
  })

  return flattened
}

const MenuSearch = ({ menuData }) => {
  const navigate = useNavigate()
  const [selectedKey, setSelectedKey] = useState(null)

  const options = flattenMenuItems(menuData)

  const handleSelect = (value) => {
    navigate(value)
    setSelectedKey(null)
  }

  const filterOption = (input, option) => {
    const searchText = normalizarString(input)
    return normalizarString(option.fullLabel).includes(searchText)
  }

  return (
    <Select
      showSearch
      placeholder="Busca rápida no menu"
      style={{ width: '300px', marginTop: '0px', marginLeft: '8px' }}
      value={selectedKey}
      onSelect={handleSelect}
      filterOption={filterOption}
      options={options.map((opt) => ({
        ...opt,
        label: (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '2px'
            }}
          >
            <div>{opt.label}</div>
            {opt.fullLabel !== opt.label && (
              <div
                style={{
                  fontSize: '12px',
                  color: '#8c8c8c',
                  fontStyle: 'italic'
                }}
              >
                {opt.fullLabel}
              </div>
            )}
          </div>
        )
      }))}
    />
  )
}

const menuItemShape = {
  key: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  path: PropTypes.string,
  subitems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      path: PropTypes.string
    })
  )
}

MenuSearch.propTypes = {
  menuData: PropTypes.arrayOf(PropTypes.shape(menuItemShape)).isRequired
}

export default MenuSearch

// Melhoria

// import { useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { Select } from 'antd'
// import PropTypes from 'prop-types'

// const { Option } = Select

// const propTypes = {
//   menuData: PropTypes.arrayOf(
//     PropTypes.shape({
//       key: PropTypes.string,
//       label: PropTypes.string,
//       children: PropTypes.arrayOf(
//         PropTypes.shape({
//           key: PropTypes.string,
//           label: PropTypes.string
//         })
//       )
//     })
//   ).isRequired
// }

// const MenuSearch = ({ menuData }) => {
//   const navigate = useNavigate()
//   const [searchValue, setSearchValue] = useState('')
//   const [selectedKey, setSelectedKey] = useState(null)

//   const handleSearch = (value) => {
//     setSearchValue(value)
//     setSelectedKey(null)
//   }

//   const handleSelect = (key) => {
//     navigate(key)
//     setSearchValue('')
//     setSelectedKey(null)
//   }

//   const renderOptions = (data) => {
//     const options = []

//     const traverse = (items) => {
//       items.forEach((item) => {
//         if (item.children && item.children.length > 0) {
//           traverse(item.children)
//         }

//         if (item.label.toLowerCase().includes(searchValue.toLowerCase())) {
//           options.push(
//             <Option key={item.key} value={item.key}>
//               {item.label}
//             </Option>
//           )
//         }
//       })
//     }

//     traverse(data)
//     return options
//   }

//   return (
//     <Select
//       optionFilterProp="children"
//       placeholder="Busca rápida no menu"
//       showSearch
//       style={{ width: '300px' }}
//       value={selectedKey}
//       onSearch={handleSearch}
//       onSelect={handleSelect}
//     >
//       {renderOptions(menuData)}
//     </Select>
//   )
// }

// MenuSearch.propTypes = propTypes

// export default MenuSearch
